"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderButton = void 0;
/*
 * © 2024 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const __1 = require("../");
const styled_components_1 = require("../styled-components");
/** Clickable table header with button styling. Use the `as={"div"}` prop to make a non-interactive header using this style. */
exports.HeaderButton = styled_components_1.styled.button `
  ${({ theme, lighten }) => (0, __1.getBackground)("normal", theme, lighten ? "light" : undefined)};
  /* If we use this with an 'as={"div"}' prop, it should not change on hover. */
  &:hover:not(div) {
    ${({ theme, lighten }) => (0, __1.getBackground)("normal", theme, "light", lighten ? 0.2 : 0.1)};
    cursor: pointer;
  }
  &:active:not(div) {
    ${({ theme }) => (0, __1.getBackground)("normal", theme, "dark")};
  }
  /* No box-shadow, it interferes with merged buttons. Put a shadow on the header as a whole. */
  color: ${({ theme }) => theme.button.color.normal};
  border-left: ${({ mergeLeft }) => (mergeLeft ? "none" : "solid #fff3")};
  border-right: ${({ mergeRight }) => (mergeRight ? "none" : "solid #0004")};
  border-width: 0 ${({ lastColumn }) => (lastColumn ? 0 : "1px")} 0
    ${({ firstColumn }) => (firstColumn ? 0 : "1px")};
  border-radius: ${({ firstColumn, theme }) => (firstColumn ? theme.radius : 0)}
    ${({ lastColumn, theme }) => (lastColumn ? theme.radius : 0)} 0 0;
  height: ${({ height }) => typeof height === "string"
    ? height
    : typeof height === "number"
        ? `${height}px`
        : "40px"};
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  min-width: 5ex;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
//# sourceMappingURL=index.js.map